module.exports = __webpack_public_path__ + "static/media/PushUps.3536128f.gif";